// extracted by mini-css-extract-plugin
export var videoContainer = "_jx-0";
export var videoIframe = "_jx-3";
export var videoLink = "_jx-1";
export var videoOverlay = "_jx-4";
export var videoOverlayText = "_jx-5";
export var videoWrapper = "_jx-2";